// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d3683f4a","165":"1400d3db","256":"b5c17714","313":"c0033f3e","421":"6225ed43","619":"20008e85","672":"ec2b0541","682":"4d89bbaa","697":"3c563fb6","977":"95487d77"}[chunkId] + ".chunk.js";
};